import New from './New';

export default New;
